import React from 'react'
import HouseCategory from './HouseCategory'
import Amenities from './Amenities'
import Summary from './Summary'

function OverviewTab() {
    return (
        <div className='space-y-12'>
            <Summary/>
            <HouseCategory/>
            <Amenities/>
        </div>
    )
}

export default OverviewTab